/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface DirectSaleRequest
 */
export interface DirectSaleRequest {
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    tableNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof DirectSaleRequest
     */
    deliveryMethodId: number;
    /**
     * 
     * @type {CartDto}
     * @memberof DirectSaleRequest
     */
    cart: CartDto;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    vatType: DirectSaleRequestVatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    discountCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    giftCardPhoneNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof DirectSaleRequest
     */
    placementId?: number;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    paymentProvider: DirectSaleRequestPaymentProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DirectSaleRequest
     */
    askForTip: boolean;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleRequest
     */
    traceId?: string;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof DirectSaleRequest
     */
    paymentMethod: PaymentMethodDto;
}


/**
 * @export
 */
export const DirectSaleRequestVatTypeEnum = {
    TAKEAWAY: 'TAKEAWAY',
    EAT_IN: 'EAT_IN'
} as const;
export type DirectSaleRequestVatTypeEnum = typeof DirectSaleRequestVatTypeEnum[keyof typeof DirectSaleRequestVatTypeEnum];

/**
 * @export
 */
export const DirectSaleRequestPaymentProviderEnum = {
    ADYEN: 'ADYEN',
    SOFTPAY: 'SOFTPAY',
    NETS: 'NETS'
} as const;
export type DirectSaleRequestPaymentProviderEnum = typeof DirectSaleRequestPaymentProviderEnum[keyof typeof DirectSaleRequestPaymentProviderEnum];


/**
 * Check if a given object implements the DirectSaleRequest interface.
 */
export function instanceOfDirectSaleRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "deviceId" in value;
    isInstance = isInstance && "deliveryMethodId" in value;
    isInstance = isInstance && "cart" in value;
    isInstance = isInstance && "vatType" in value;
    isInstance = isInstance && "paymentMethodId" in value;
    isInstance = isInstance && "paymentProvider" in value;
    isInstance = isInstance && "askForTip" in value;
    isInstance = isInstance && "paymentMethod" in value;

    return isInstance;
}

export function DirectSaleRequestFromJSON(json: any): DirectSaleRequest {
    return DirectSaleRequestFromJSONTyped(json, false);
}

export function DirectSaleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectSaleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'deviceId': json['deviceId'],
        'tableNumber': !exists(json, 'tableNumber') ? undefined : json['tableNumber'],
        'deliveryMethodId': json['deliveryMethodId'],
        'cart': CartDtoFromJSON(json['cart']),
        'vatType': json['vatType'],
        'discountCode': !exists(json, 'discountCode') ? undefined : json['discountCode'],
        'giftCardPhoneNumber': !exists(json, 'giftCardPhoneNumber') ? undefined : json['giftCardPhoneNumber'],
        'placementId': !exists(json, 'placementId') ? undefined : json['placementId'],
        'paymentMethodId': json['paymentMethodId'],
        'paymentProvider': json['paymentProvider'],
        'askForTip': json['askForTip'],
        'traceId': !exists(json, 'traceId') ? undefined : json['traceId'],
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
    };
}

export function DirectSaleRequestToJSON(value?: DirectSaleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'deviceId': value.deviceId,
        'tableNumber': value.tableNumber,
        'deliveryMethodId': value.deliveryMethodId,
        'cart': CartDtoToJSON(value.cart),
        'vatType': value.vatType,
        'discountCode': value.discountCode,
        'giftCardPhoneNumber': value.giftCardPhoneNumber,
        'placementId': value.placementId,
        'paymentMethodId': value.paymentMethodId,
        'paymentProvider': value.paymentProvider,
        'askForTip': value.askForTip,
        'traceId': value.traceId,
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
    };
}

